import { inject, Injectable } from '@angular/core';
import { DELETE, MANAGE, VIEW, AppModulePath, IRolePermisssionModel } from '@medicalapp/shared-core';
import { CurrentUserService } from './current-user.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private currentUserService = inject(CurrentUserService);

  /**
   * Resolves the given path to a registered module (via AppModulePath)
   */
  checkAppModuleAccess(path: string): boolean {
    const matchedModule = AppModulePath.find((module) =>
      module.accessiblePaths?.some((accessiblePath) => path?.includes(accessiblePath))
    );
    const moduleName = matchedModule?.moduleName || '';

    const permissions = this.currentUserService.currentUser()?.permissions;
    const permission = permissions?.find(
      (p: IRolePermisssionModel) => p.ModuleName === moduleName
    );
    return !!permission?.CanView;
  }

  /**
   * Checks a single permission (VIEW / MANAGE / DELETE) for a given module.
   */
  checkAppModulePermission(module: string, permission: string): boolean {
    const permissions = this.currentUserService.currentUser()?.permissions;
    const rolePermission = permissions?.find(
      (p: IRolePermisssionModel) => p.ModuleName === module
    );

    switch (permission) {
      case VIEW:
        return !!rolePermission?.CanView;
      case MANAGE:
        return !!rolePermission?.CanManage;
      case DELETE:
        return !!rolePermission?.CanDelete;
      default:
        return false;
    }
  }

  checkAppModuleActionPermissions(module: string, permissions: string[]): boolean {
    const rolePermission = this.currentUserService
      .currentUser()
      ?.permissions?.find((p: IRolePermisssionModel) => p.ModuleName === module);

    if (!rolePermission) return false;

    return permissions.some(
      (permission) =>
        (permission === MANAGE && rolePermission.CanManage) ||
        (permission === DELETE && rolePermission.CanDelete)
    );
  }
}